// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Q8U","content":"styles_content__RcmmL","row":"styles_row__O8dZf","footer":"styles_footer__2pMTD","phraseLength":"styles_phraseLength__2iQM0"};